module.exports = "<div class=\"all-wrapper menu-side solid-bg-all with-pattern\">\n    <app-header></app-header>\n    <div class=\"layout-w\">\n       <!--  <app-mobilesidebar class=\"menu-mobile menu-activated-on-click color-scheme-dark\"></app-mobilesidebar> -->\n        <app-sidebar class=\"desktop-menu menu-side-v2-w menu-activated-on-hover flying-menu\"></app-sidebar>\n        <div class=\"content-w\">\n            <router-outlet></router-outlet>\n        </div>\n    </div>\n    <app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/_layout/content/content.component.html
// module id = ./src/app/_layout/content/content.component.html
// module chunks = main